<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-autocomplete
        v-if="!this.campo || this.campo === 'campus'"
        :label="labels.campus"
        v-model="form.campus.id"
        :error-messages="errors.campus"
        :rules="[rules.required('campus')]"
        :disabled="loading"
        :items="auth.campuses"
        item-text="nombre"
        item-value="id"
        dense
      ></v-autocomplete>

      <v-text-field
        v-if="!this.campo || this.campo === 'uuid'"
        :label="labels.uuid"
        v-model="form.uuid"
        :error-messages="errors.uuid"
        :rules="[rules.required('uuid')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'nombre'"
        :label="labels.nombre"
        v-model="form.nombre"
        :error-messages="errors.nombre"
        :rules="[rules.required('nombre')]"
        :disabled="loading"
      ></v-text-field>

      <v-select
        v-if="!this.campo || this.campo === 'nivel_de_estudio'"
        :label="labels.nivel_de_estudio"
        v-model="form.nivel_de_estudio.id"
        :error-messages="errors.nivel_de_estudio"
        :rules="[rules.required('nivel_de_estudio')]"
        :disabled="loading"
        :items="nivel_de_estudio"
        item-text="nombre"
        item-value="id"
        dense
      ></v-select>

      <v-text-field
        v-if="!this.campo || this.campo === 'clave'"
        :label="labels.clave"
        v-model="form.clave"
        :disabled="loading"
      ></v-text-field>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      form: {
        nivel_de_estudio: {}
      },
      nivel_de_estudio: [],
      campo: null
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
        auth: 'auth/user',
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'carrera' })
        }
      }
    },

    mounted() {
      if(this.$route.params.campo) {
        this.campo = this.$route.params.campo
      } else {
        let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')
        let param = decodeURI(tab[0].substr(1))
        if (
          param === 'campus' ||
          param === 'uuid' ||
          param === 'nombre' ||
          param === 'nivel_de_estudio' ||
          param === 'clave'
        ) {
          this.campo = param
        }
      }

      if(this.campo) {
        this.$router.replace('#' + this.campo)
      }

      if(!this.campo || this.campo === 'nivel_de_estudio') {
        this.getCatalogoNivelDeEstudio()
      }

      this.getCarrera(this.$route.params.id)
    },

    methods: {
      getCatalogoNivelDeEstudio() {
        axios
          .get(api.path('catalogos.nivel_de_estudio'))
          .then(res => {
            this.nivel_de_estudio = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCarrera(id) {
        this.loading = true
        axios
          .get(api.path('carreras.single', { id: id } ), {
            params: {
              campo: this.campo
            }
          })
          .then(res => {
            this.form = res.data
            if (!this.form.campus) {
              this.form.campus = {}
            }
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
            this.loading = false
          })
      },

      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          axios.put(api.path('carreras.single', { id: this.$route.params.id }), this.form)
            .then(res => {
              this.$toast.success('Carrera actualizado correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
